export default "/images/document_icon.png?ebaeee5175ee0589bbf567ac8365d85d";